enum BucketSize {
    Hour = 'hour',
    Day = 'day',
    Month = 'month',
    Year = 'year',
}

export default BucketSize;
